<template>
    <section class="container">

        <header class="container__header">

            <h1>Allergener</h1>

            <router-link class="btn btn--md btn--primary primary--copper margin-t-50" :to="{name:'tag.create'}">Tilføj ny ingrediens</router-link>

        </header>

        <section class="container__body container__body--md">

            <header class="col-12 flex--space padding-b-25 border-b">

                <h1>Oversigt</h1>

            </header>

            <section class="data-list">

                <transition-group name="fade" tag="section">

                    <section class="item" v-for="tag in tags" :key="tag.id">

                        <section class="icon">

                            <i class="icon--lg fas fa-shopping-bag"></i>

                        </section>

                        <section class="content">

                            <h1 v-text="tag.name"></h1>


                        </section>

                        <section class="link">

                            <router-link :to="{name:'tag.edit', params:{tag:tag.id}}">Administrer</router-link>

                        </section>

                    </section>

                </transition-group>

            </section>

        </section>

    </section>
</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        name: "tag-index",
        computed:{
            ...mapGetters(['tags']),
        },
        created(){
            this.$store.dispatch('getTags');
        }
    }
</script>

<style scoped>

</style>
